enum DriverContractAddViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default DriverContractAddViewMode;
